import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
type Testimonial = {
  title: string;
  quote: string;
  author: string;
  age: number;
  image: string;
};
const testimonials: Testimonial[] = [{
  title: 'Bajé mis picos de glucosa sin dieta extrema',
  quote: 'Solo con el consejo de cambiar el orden de mis alimentos (Capítulo 10), mis mediciones después de almorzar mejoraron radicalmente. ¡Es ciencia pura aplicada de forma simple!',
  author: 'Elena G.',
  age: 48,
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'Mi familia ahora está protegida',
  quote: 'El bono del azúcar infantil me abrió los ojos sobre lo que les daba a mis hijos. Cambiamos la lonchera y su energía es otra. ¡Gracias, Roderic!',
  author: 'Claudia P.',
  age: 35,
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'Por fin entiendo mis análisis',
  quote: 'Antes veía mis resultados de laboratorio con miedo. Ahora entiendo qué es la glicación y cómo controlarla. El conocimiento me dio paz.',
  author: 'Marcos T.',
  age: 54,
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'El truco de los 15 minutos funciona',
  quote: 'El mecanismo de rescate del Capítulo 12 es mi salvavidas en las reuniones familiares. Me permite disfrutar sin culpa y sin dañar mi salud.',
  author: 'Javier S.',
  age: 45,
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'Si él pudo con 6 bypass, yo puedo con esto',
  quote: 'Lo que hace este libro diferente es que el autor es un sobreviviente. Roderic no te habla desde la teoría, sino desde la experiencia de haber estado al borde de la muerte. Esa honestidad te motiva a actuar desde el primer día.',
  author: 'Ricardo M.',
  age: 62,
  image: 'https://images.unsplash.com/photo-1559963110-71b394e7494d?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'Ya no me engañan en el supermercado',
  quote: 'Gracias a la Guía de Azúcares Ocultos, descubrí que mi pan "saludable" tenía azúcar con otro nombre. Aprender a leer las etiquetas ha sido la mejor inversión para mi despensa y mi salud.',
  author: 'Marta L.',
  age: 57,
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'Plan de 14 días increíble',
  quote: 'Seguí el plan paso a paso y al día 15 mi energía era otra. Ya no necesito café a las 3 de la tarde para no quedarme dormida. Es un sistema práctico que cualquiera puede seguir.',
  author: 'Beatriz M.',
  age: 65,
  image: 'https://images.unsplash.com/photo-1581579438747-104c53e7b78a?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'El estrés era mi enemigo oculto',
  quote: 'No sabía que el cortisol elevaba mi glucosa tanto como un postre. Gracias al bono sobre el estrés, aprendí a regular mis niveles incluso en días difíciles de trabajo. ¡Clave para cualquier profesional!',
  author: 'Sonia R.',
  age: 39,
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'La mejor explicación sobre el corazón y el azúcar',
  quote: 'Un mapa claro para evitar complicaciones futuras. Lo recomiendo a ojos cerrados.',
  author: 'Luis H.',
  age: 51,
  image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'Práctico, honesto y directo al grano',
  quote: 'Pasé de la confusión total a tomar el control de mi metabolismo en una tarde de lectura.',
  author: 'Andrés B.',
  age: 42,
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces'
}, {
  title: '¡Es un manual de instrucciones para el cuerpo!',
  quote: 'Deberían dar este libro en cada consulta médica. Imprescindible si tienes azúcar alta.',
  author: 'Miguel A.',
  age: 58,
  image: 'https://images.unsplash.com/photo-1542178243-bc20204b769f?w=200&h=200&fit=crop&crop=faces'
}, {
  title: 'Recuperé mi energía y mi calma',
  quote: 'Entender el daño silencioso me permitió detenerlo. El mejor libro de salud que tengo.',
  author: 'Patricia V.',
  age: 46,
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=faces'
}];
// Duplicate for seamless infinite loop
const loopedTestimonials = [...testimonials, ...testimonials];
export function Testimonials() {
  return <section className="relative bg-ivory py-[40px] md:py-[64px] overflow-hidden" data-id="element-249">
      <div className="max-w-[860px] mx-auto px-6" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8 text-center" data-id="element-251">
          <p className="font-mono text-[11px] tracking-[0.15em] text-cocoa uppercase mb-6" data-id="element-252">
            LO QUE DICEN LOS LECTORES
          </p>

          <h2 className="font-serif font-[900] text-[42px] md:text-[44px] leading-[1.15] text-text-primary max-w-[620px] mx-auto" data-id="element-253">
            Familias que ya entendieron lo que estaba pasando.
          </h2>
        </motion.div>
      </div>

      {/* Carousel — full bleed, fade edges, infinite right-to-left */}
      <div className="relative w-full" data-id="element-254">
        {/* Edge fade masks */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 md:w-40 z-10 bg-gradient-to-r from-ivory to-transparent" data-id="element-255" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 md:w-40 z-10 bg-gradient-to-l from-ivory to-transparent" data-id="element-256" />

        <motion.div className="flex gap-6 w-max py-4" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 90,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-257">
          {loopedTestimonials.map((t, index) => <article key={index} className="premium-card p-8 md:p-10 w-[320px] md:w-[400px] flex-shrink-0 flex flex-col" data-id="element-258">
              <div className="flex gap-1 mb-5" data-id="element-259">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-cocoa text-cocoa" data-id="element-260" />)}
              </div>

              <h3 className="font-serif font-bold text-[18px] leading-[1.3] text-text-primary mb-3" data-id="element-261">
                {t.title}
              </h3>

              <p className="font-lora italic text-[16px] leading-[1.6] text-text-secondary mb-6 flex-1" data-id="element-262">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3 pt-5 border-t border-border" data-id="element-263">
                <img src={t.image} alt={t.author} className="w-11 h-11 rounded-full object-cover flex-shrink-0" loading="lazy" data-id="element-264" />
                <div data-id="element-265">
                  <p className="font-semibold text-[14px] text-text-primary leading-tight" data-id="element-266">
                    {t.author}
                  </p>
                  <p className="font-mono text-[11px] text-text-muted mt-0.5" data-id="element-267">
                    {t.age} años
                  </p>
                </div>
              </div>
            </article>)}
        </motion.div>
      </div>

      {/* Section Separator */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-b from-transparent to-ivory" data-id="element-268"></div>
    </section>;
}